import { render } from "solid-js/web";
import { genRequest } from '#src/client/common/utils/browser/fetchHelper.js';
import StandardStore from "#src/client/common/stores/StandardStore";
import update from "#src/client/common/utils/update.js";
import LoginPageDirector from "#src/client/members/Login/LoginPageDirector.js";
import Shell from "#src/client/members/common/layout/Shell.jsx";
import PageTitle from "#src/client/members/common/layout/PageTitle.jsx";
import PagePadding from "#src/client/common/layout/PagePadding.jsx";
import Items from "#src/client/common/layout/Items.jsx";
import SubmitArea from "#src/client/common/SubmitArea.jsx";
import LabeledInput from "#src/client/common/interactive/LabeledInput.jsx";
import { batch, createSignal } from "solid-js";
import { addNotificationErrors, dismissAllNotificationErrors } from '#src/client/common/notifications/NotificationsDirector.jsx';

const [store, updateStore] = StandardStore(LoginPageDirector);

// Simplistic page to prove solidjs is working
function Page(props) {
    const [isSaving, setIsSaving] = createSignal(false);

    const onLogin = async () => {
        batch(() => {
            setIsSaving(true);
            dismissAllNotificationErrors();
        });

        const [errors, content] = await genRequest({
            url: props.state.urlApiLogin,
            body: LoginPageDirector.transformClientData(props.state),
        });

        batch(() => {
            setIsSaving(false);
            if (errors) {
                addNotificationErrors(errors);
            }
        });
    }

    const updateFieldAt = (key) => {
        return (value) => {
            update(props, (state) => {
                state[key] = value;
            });
        };
    };
    const onKeyDown = (e) => {
        if (e.key === 'Enter' && !props.state.e.all) {
            onLogin();
        }
    };

    return (
        <Shell meta={props.state.meta}>
            <PageTitle>{props.state.meta.title}</PageTitle>

            <PagePadding limitWidth={true}>
                <fieldset disabled={isSaving()}>
                    <Items size="large">
                        <LabeledInput
                            state={props.state.username}
                            update={updateFieldAt("username")}
                            error={props.state.e.username}
                            onKeyDown={onKeyDown}
                            label="Email"
                            type="email" />
                        <LabeledInput
                            state={props.state.password}
                            update={updateFieldAt("password")}
                            error={props.state.e.password}
                            onKeyDown={onKeyDown}
                            label="Password"
                            type="password" />
                        <SubmitArea
                            errorAll={props.state.e.all}
                            onSubmit={onLogin}
                            submitText="Login"
                        />
                    </Items>
                </fieldset>
            </PagePadding>
        </Shell>
    );
}

render(() => (
    <Page state={store} path={[]} update={updateStore} />
), document.getElementById('root'));